module.exports = __webpack_public_path__ + "static/img/404-number.fc02028.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/404-number.png
// module id = 500
// module chunks = 7